// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3GYjw","list":"BalanceDue_list__wIDO5","listRow":"BalanceDue_listRow__2RsjR","total":"BalanceDue_total__UaAgc"};